import { ExpressionType } from '../../../../expressions/IExpression';
import { ComputeExpression } from '../../../../expressions/compute/ComputeExpression';
import { useExpressionValue } from '../../../../expressions/render/hooks/useExpressionValue';

/**
 * Gestisce la risoluzione dell'espressione del campo calcolato numerico.
 * Richiama l'hook di risoluzione dell'espressione, creando la ComputeExpression
 * e aggiungendo la funzione di skip (che salta il calcolo se una delle variabili
 * è undefined). Questo perché altrimenti il risolutore lancia eccezioni se tutte le
 * variabili non sono definite.
 */
export function useNumberExpressionValue(
  name: string,
  expression: ComputeExpression,
): number | null {
  const expressionValue = useExpressionValue(
    name,
    { type: ExpressionType.Function, value: expression },
    {
      // No, vedi `considerNullsAsZero` in `EvaluationScope`
      // skip: variables => {
      //   return Object.values(variables).some(v => v === undefined);
      // }
    },
  );

  return expressionValue.type === 'value'
    ? Number(expressionValue.result)
    : null;
}
